module.exports = __webpack_public_path__ + "4559e65604846d7962517f3215a999d0.png";